"use strict";
module.exports = {
  MODE_ENV: "development",
  BASE_API: "https://pub.servicesplus.cn/api/web",
  IMAGE_API: "https://pub.servicesplus.cn/api"
};
